module.exports = __webpack_public_path__ + "img/hot.788aeb50.788aeb50.png";